// http://reactivex.io/rxjs/file/es6/util/isFunction.js.html

export default (x) => {
    return typeof x === 'function';
}